import React from "react";
import { BrandConfig } from "./types";
import { BrandProvider } from "./BrandProvider";
import { useBrandDocumentMeta } from "./useBrandDocumentMeta";

interface BrandScopeProps {
  brand: BrandConfig;
  children: React.ReactNode;
}

// Escopo de marca por dispatcher: aplica o tema (BrandProvider) e o título/favicon da marca.
// Só a variante BRANDED de cada rota é envolvida por ele; Default/IDP/Trading/NotPortal
// seguem com o tema do App.tsx. Vale também em acesso direto por link do e-mail.
const BrandMeta: React.FC<{ brand: BrandConfig }> = ({ brand }) => {
  useBrandDocumentMeta(brand);
  return null;
};

export const BrandScope: React.FC<BrandScopeProps> = ({ brand, children }) => (
  <BrandProvider brand={brand}>
    <BrandMeta brand={brand} />
    {children}
  </BrandProvider>
);
